import React from 'react';
import { FIELD_TYPES } from '../../../constants';
import { TextInputFieldWUT } from '../../../ui/text-input-field';
export const ContactsCompanyWUT = (props)=>{
    const fieldType = FIELD_TYPES.CONTACTS_COMPANY;
    return /*#__PURE__*/ React.createElement(TextInputFieldWUT, {
        ...props,
        fieldType: fieldType
    });
};

//# sourceMappingURL=contacts-company-wut.js.map